import { isGookiEnv } from '@/utils/env';

const store = {
  namespaced: true,
  state: {
    tts: {},
    asr: {},
    vars: [],
    transfer: {},
    sms: {},
    general: {},
    multi_Prologue: {},
    ratings: {},
    apiSettings: {},
    echo_word: {},
    sysVars: [
      // { id: 'yes-hits', name: '肯定命中次数', type: 'NUM' },
      // { id: 'no-hits', name: '否定命中次数', type: 'NUM' },
      // { id: 'refuse-hits', name: '拒绝次数', type: 'NUM' },
      { id: 'miss-hits', name: '未命中次数', type: 'NUM' },
      { id: 'round', name: '对话轮次', type: 'NUM' },
      { id: 'business-hits', name: '业务问题命中次数', type: 'NUM' },
      { id: 'normal-hits', name: '一般问题命中次数', type: 'NUM' },
      { id: 'duration', name: '通话时长(秒)', type: 'NUM' },
      { id: 'ring-duration', name: '振铃时长(秒)', type: 'NUM' },
      { id: 'rating', name: '评级', type: 'NUM' },
      { id: 'tags', name: '标签', type: 'STR' },
      { id: 'block-robot', name: '拦截语音助手', type: 'STR' },
      { id: 'hmc', name: '是否触发人机协同', type: 'STR' },
      { id: 'onscreen', name: '是否弹屏', type: 'STR' },
      { id: 'takeover-duration', name: '接管时长(秒)', type: 'NUM' },
      { id: 'hangup-reason', name: '挂机原因', type: 'STR' },
      { id: 'caller-hangup', name: '是否主动挂机', type: 'STR' },
      { id: "is-transfer-success", name: "是否成功转接", type: "STR" },
      { id: "user-intents", name: "命中的意图（以空格分隔）", type: "STR" },
      { id: "user-last-words", name: "最近的发言", type: "STR" },
    ],
    llm: {},
    multi_prologue: {}
  },
  getters: {
    varMap: (state) => {
      return state.vars?.reduce((item, next) => {
        return { ...item, [next.name]: next }        
      }, {})
    }
  },
  mutations: {
    SET_TTS(state, tts = {}) {
      state.tts = tts;
    },
    SET_ASR(state, asr = {}) {
      state.asr = asr;
    },
    SET_TRANSFER(state, transfer = {}) {
      state.transfer = transfer;
    },
    SET_SMS(state, sms = {}) {
      state.sms = sms;
    },
    SET_VARS(state, vars = []) {
      state.vars = vars;
    },
    SET_LLM(state, llm = {}) {
      state.llm = llm;
    },
    ADD_VAR(state, curVar) {
      state.vars.push(curVar);
    },
    UPDATE_VAR(state, curVar) {
      const index = state.vars.findIndex(item => item.name === curVar.id);
      if (index < 0) return;
      state.vars.splice(index, 1, {
        name: curVar.name,
        type: curVar.type,
        value: curVar.value,
        export: curVar.export,
        first_valid: !!curVar.first_valid,
      });
    },
    DEL_VAR(state, varName) {
      const index = state.vars.findIndex(item => item.name === varName);
      if (index < 0) return;
      state.vars.splice(index, 1)
    },
    SET_GENERAL(state, general = {}) {
      state.general = general;
    },
    SET_RATINGS(state, ratings = {}) {
      state.ratings = ratings;
    },
    SET_APISETTINGS(state, apiSettings = {}) {
      state.apiSettings = apiSettings;
    },
    SET_MUTI_PROLOGUE(state, multiPrologue = {}) {
      state.multi_prologue = multiPrologue;
    },
    SET_ECHO_WORD(state, echoWord = {}) {
      state.echo_word = echoWord;
    },
  },
  actions: {
    updateTts({ commit, dispatch }, newTts) {
      commit('SET_TTS', newTts);
      dispatch('saveSettings')
    },
    updateAsr({ commit, dispatch }, newAsr) {
      commit('SET_ASR', newAsr);
      dispatch('saveSettings')
    },
    updateTransfer({ dispatch }, newTransfer) {
      return dispatch('saveSettings', { transfer: newTransfer }).then((result) => {
        if (isGookiEnv()) {
          dispatch('flow/reportShengwangWarmup', {
            phoneNumber: String(newTransfer.transfer_phone || '').trim(),
          }, { root: true }).catch(() => {});
        }
        return result;
      });
    },
    updateSms({ commit, dispatch }, newSms) {
      commit('SET_SMS', newSms);
      dispatch('saveSettings')
    },
    updateLLM({ commit, dispatch }, newLLM) {
      commit('SET_LLM', newLLM);
      dispatch('saveSettings')
    },
 
    saveVar({ commit, dispatch }, curVar) {
      if (curVar.id) {
        commit('UPDATE_VAR', curVar);
      } else {
        commit('ADD_VAR', curVar);
      }
      dispatch('saveSettings')
    },
    delVar({ commit, dispatch }, varName) {
      commit('DEL_VAR', varName)
      dispatch('saveSettings')
    },
    updateGeneral({ commit, dispatch }, general) {
      commit('SET_GENERAL', general);
      dispatch('saveSettings')
    },
    updateRatings({ commit, dispatch }, ratings) {
      commit('SET_RATINGS', ratings);
      dispatch('saveSettings')
    },
    updateApiSettings({ commit, dispatch }, apiSettings) {
      commit('SET_APISETTINGS', apiSettings);
      dispatch('saveSettings')
    },
    updateMultiPrologue({ commit, dispatch }, multiPrologue) {
      commit('SET_MUTI_PROLOGUE', multiPrologue);
      dispatch('saveSettings')
    },
    updateEchoWord({ commit, dispatch }, echoWord) {
      commit('SET_ECHO_WORD', echoWord);
      dispatch('saveSettings')
    },
    updateGeneralAndEchoWord({ commit, dispatch }, { general, echoWord }) {
      commit('SET_GENERAL', general);
      commit('SET_ECHO_WORD', echoWord);
      return dispatch('saveSettings')
    },
    setSettings({ commit }, settings = {}) {
      commit('SET_TTS', settings.tts);
      commit('SET_ASR', settings.asr);
      commit('SET_TRANSFER', settings.transfer);
      commit('SET_SMS', settings.sms);
      commit('SET_VARS', settings.vars);
      commit('SET_GENERAL', settings.general);
      commit('SET_MUTI_PROLOGUE', settings.multi_prologue);
      commit('SET_RATINGS', settings.ratings);
      commit('SET_APISETTINGS', settings.apiSettings);
      commit('SET_LLM', settings.llm);
      commit('SET_ECHO_WORD', settings.echo_word);
    },
    saveSettings({ state, dispatch }, { transfer = state.transfer } = {}) {
      const setting = {
        tts: state.tts,
        asr: state.asr,
        transfer,
        sms: state.sms,
        vars: state.vars.filter(Boolean),
        general: state.general,
        ratings: state.ratings,
        apiSettings: state.apiSettings,
        multi_prologue: state.multi_prologue,
        llm: state.llm,
        echo_word: state.echo_word,
      }
      return dispatch('scene/savePortionScene', { key: 'settings', data: setting }, { root: true })
    },
  },
  modules: {
  }
}
export default store
